import React from 'react';
import { motion } from 'framer-motion';
import { Home, History, Send, MessageCircle, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const BottomNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { icon: Home, label: 'Inicio', path: '/home' },
    { icon: History, label: 'Historial', path: '/history' },
    { icon: Send, label: 'Enviar', path: '/send/step1', primary: true },
    { icon: MessageCircle, label: 'Soporte', path: '/support' },
    { icon: User, label: 'Perfil', path: '/profile' }
  ];

  const handleNavigation = (path, label) => {
    if (label === 'Soporte') {
      window.open('https://wa.me/573241437215', '_blank');
      return;
    }
    navigate(path);
  };

  const isActive = (path) => {
    if (path === '/send/step1') {
      return location.pathname.startsWith('/send');
    }
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <motion.div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-xl border-t border-gray-200/70 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', damping: 25, stiffness: 180 }}
    >
      <div className="flex items-center justify-around max-w-md mx-auto px-2 py-3">
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          const isPrimary = item.primary;

          return (
            <motion.button
              key={item.path}
              onClick={() => handleNavigation(item.path, item.label)}
              className={`
                relative flex flex-col items-center justify-center flex-1 py-2 px-3 rounded-2xl transition-all duration-300
                ${isPrimary 
                  ? ' -mt-10 scale-110 shadow-xl shadow-blue-900/30 bg-gradient-to-b from-blue-900 to-blue-800 text-white' 
                  : active 
                    ? 'text-blue-900 bg-blue-50/80' 
                    : 'text-gray-500 hover:text-blue-700 hover:bg-blue-50/50'
                }
              `}
              whileHover={{ scale: isPrimary ? 1.08 : 1.06 }}
              whileTap={{ scale: isPrimary ? 0.96 : 0.94 }}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ 
                delay: index * 0.08,
                type: 'spring',
                damping: 20,
                stiffness: 150
              }}
            >
              {/* Efecto de ripple sutil en el botón principal */}
              {isPrimary && (
                <div className="absolute inset-0 rounded-2xl bg-white/10 animate-pulse-slow" />
              )}

              <div className={`
                relative z-10 w-11 h-11 flex items-center justify-center rounded-full transition-all
                ${isPrimary 
                  ? 'bg-white/20 backdrop-blur-sm' 
                  : active 
                    ? 'bg-blue-100' 
                    : 'bg-transparent'
                }
              `}>
                <Icon 
                  className={`
                    w-6 h-6 transition-all duration-300
                    ${isPrimary ? 'text-white drop-shadow-md' : active ? 'text-blue-900' : ''}
                  `}
                />
              </div>

              <span className={`
                mt-1.5 text-xs font-medium tracking-wide transition-all
                ${isPrimary ? 'text-white font-semibold' : active ? 'text-blue-900 font-semibold' : 'text-gray-600'}
              `}>
                {item.label}
              </span>

              {/* Indicador activo sutil (punto debajo) */}
              {active && !isPrimary && (
                <div className="absolute bottom-1 w-1.5 h-1.5 bg-blue-600 rounded-full" />
              )}
            </motion.button>
          );
        })}
      </div>
    </motion.div>
  );
};

export default BottomNavigation;
